import React from 'react';
import { Trans, t } from '@lingui/macro';
import Head from 'next/head';
import Footer from '../components/Footer';
import Layout from '../components/Layout';
import styles from '../styles/about.module.scss';
import Header from '../components/Home/Header';
import { ciaociaoId, ABOUT_PAGE } from '../utils/static';
import {
    getCityNum,
} from '../utils/getPageProps';

const About = ({ locale, cityNum, seo }) => (
    <Layout className={styles.body} seo={seo} locale={locale}>
        <Header locale={locale} />
        <div className="container mt-5 mb-5" style={{ minHeight: '60vh' }}>
            <h1 className={styles.discussTitle}>
                <Trans id="about.title" />
            </h1>
            <div>
                <p>
                    <Trans id="about.line1" />
                </p>
                <p>
                    <Trans
                        id="about.line2"
                        values={{ cityNum }}
                        components={{ 0: <b /> }}
                    />
                </p>
                <p>
                    <Trans id="about.line3" />
                </p>
                <p>
                    <Trans id="about.line4" components={{0: <a href='mailto:contact@visualization.bike' />}}/>
                </p>
            </div>
        </div>
        <Head>
            <script src="https://cdn.moin.bz/widget.js" data-pid={ciaociaoId[locale]} async />
        </Head>
        <Footer locale={locale} />
    </Layout>
);

export async function getStaticProps(context) {
    const { locale } = context;
    return {
        props: {
            locale,
            cityNum: getCityNum(),
            seo: {
                page: ABOUT_PAGE,
            }
        }, // will be passed to the page component as props
    };
}
export default About;
